<template>
    <div class="chain-options__content chain-options__content-free">
        <div class="chain-options__select-options">
            <div class="label_chain_option">
                <label class="chain-options__label chain-options__label--free ">{{ titleChainOption }} <span>Free</span></label>
            </div>
        </div>
        <div class="list_chain-options__select-chain active">
            <div class="chain-options__select-chain" v-for="(chainProduct, index) in chainProducts" :key="index" :data-key="index" >
                <div class="chain-options__chain-product">  
                    <div class="chain-options__product-thumbnail" @click="show_engraving__modal(9999)">
                        <img width="700" height="700" :src="`${baseUrl}api/wp-content/uploads/${chainProduct.product_image}` " class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" alt="" decoding="async">
                        <div class="chain-options__zoom-hover">
                        <img src="/single-product/zoom-icon.webp" alt="zoom-icon">
                        </div>
                    </div>
                    <div class="chain-options__product-details">
                        <a class="chain-options__product-title" :href="getLangUrl(`/product/${chainProduct.slug}`, baseUrl, countryShort) ">
                            <div class="title-chain">{{ chainProduct.name }}</div>
                        </a>

                         <span class="chain-options__variation-price">
                            
                            <del>{{ displayCustomPrice(chainProduct.regularPrice.toString()) }}</del>
                            <span>Free</span>
                            
                          </span>

                        
                        <input type="hidden" name="chain-options__free" id="chain-options-free" :value="chainProduct.id">
                        
                    </div>
                </div>
                <div class="alt-engraving__modal " :id="'alt-engraving__modal_' + '9999'">
                    <span class="alt-engraving__modal-close" @click="close_engraving__modal(9999)">×</span>
                    <div class="alt-engraving__modal-image">
                        <img :src="`${baseUrl}api/wp-content/uploads/${chainProduct.product_image}`" alt="" />
                    </div>
                </div>
            </div>
        </div>
        
    </div>
   
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_chain.scss";
</style>

<script setup lang="ts">
import { onMounted, ref, computed, watch } from 'vue'
import ChainItem from './ChainItem.vue'
import { getLangUrl } from '~/utils/getLangUrl';
import { displayCustomPrice } from '~/utils/displayPrice';

const props = defineProps({
  data: {
    type: Object,
    required: true
  }
})

const runtimeConfig = useRuntimeConfig()
const baseUrl = runtimeConfig.public.BASE_URL
const wooStore = useWooStore()
const countryShort = wooStore.country?.country_short
const chainOptionData = computed(() => props.data)
const chainProducts = computed(() => chainOptionData.value.chainProduct ?? [])
const titleChainOption = computed(() => chainOptionData.value.titleChainOption ?? '')

const show_engraving__modal = (index: number) => {
    const showengravingModal = document.querySelector(`#alt-engraving__modal_${index}`);
    if (showengravingModal) {
        showengravingModal.classList.add("active");
    }
};


const close_engraving__modal = (index: number) => {
    const close_engraving__modal = document.querySelector(`#alt-engraving__modal_${index}`);
    if (close_engraving__modal) {
        close_engraving__modal.classList.remove("active");
    }
};

onMounted(() => {   
})
</script>

